import type { ExtractionItem } from "@l30/shared";

/** Counts used to enable Accept-all / Apply and the post-accept banner. */
export function extractionReviewActionState(items: ExtractionItem[]): {
  pendingCount: number;
  autoPendingCount: number;
  acceptedCount: number;
  showApplyBanner: boolean;
  canAcceptAllPending: boolean;
  canAcceptAllHighConfidence: boolean;
  canApply: boolean;
} {
  const pendingCount = items.filter((i) => i.status === "pending").length;
  const autoPendingCount = items.filter((i) => i.band === "auto" && i.status === "pending").length;
  const acceptedCount = items.filter((i) => i.status === "accepted").length;
  return {
    pendingCount,
    autoPendingCount,
    acceptedCount,
    showApplyBanner: pendingCount === 0 && acceptedCount > 0,
    canAcceptAllPending: pendingCount > 0,
    canAcceptAllHighConfidence: autoPendingCount > 0,
    canApply: acceptedCount > 0,
  };
}

export function proposalSummary(items: ExtractionItem[]): string {
  const total = items.length;
  const highConf = items.filter((i) => i.band === "auto").length;
  const toReview = items.filter((i) => i.status === "pending").length;
  return `${total} proposal${total !== 1 ? "s" : ""} · ${highConf} high-confidence · ${toReview} to review`;
}

export function extractionSourceLabel(sourceKind: string): string {
  if (sourceKind === "text") return "Text / MCP capture";
  if (sourceKind === "chat") return "Chat extract";
  if (sourceKind === "document") return "Document";
  return sourceKind;
}

function payloadStr(payload: ExtractionItem["payload"], key: string): string {
  const v = payload[key];
  return typeof v === "string" ? v : "";
}

export function extractionItemTitle(item: ExtractionItem): string {
  if (item.itemType === "node") return payloadStr(item.payload, "label") || "(node)";
  if (item.itemType === "context") return payloadStr(item.payload, "nodeLabel") || "(context)";
  return `${payloadStr(item.payload, "from")} → ${payloadStr(item.payload, "to")}`;
}

export function extractionItemDetail(item: ExtractionItem): string {
  if (item.itemType === "node") {
    return [payloadStr(item.payload, "kind"), payloadStr(item.payload, "summary")]
      .filter(Boolean)
      .join(" · ");
  }
  if (item.itemType === "context") return payloadStr(item.payload, "text");
  return payloadStr(item.payload, "rel");
}
